import { z } from 'zod';

export const HeroHandleSchema = z.enum(['assassin','battle_mage','dreamsmith','invoker','knight','mercenary','monk','paladin','ranger','shaman','warlock']);

export type HeroHandleType = `${z.infer<typeof HeroHandleSchema>}`

export default HeroHandleSchema;
